<script setup lang="ts">
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

interface Ticket {
    label: string
    value: number
}

interface WorkshopGroup {
    workshop: string
    tickets: Ticket[]
}

interface Props {
    tickets: WorkshopGroup[]
    modelValue: number[]
    error?: string
    label?: string
    required?: boolean
}

interface Emits {
    (e: 'update:modelValue', value: number[]): void
}

const props = withDefaults(defineProps<Props>(), {
    label: 'Selecionar categorias participantes',
    required: true,
})

const emit = defineEmits<Emits>()

function handleCategory(id: number) {
    const currentSelection = props.modelValue || []
    const newSelection = currentSelection.includes(id) ? currentSelection.filter((ticket) => ticket !== id) : [...currentSelection, id]

    emit('update:modelValue', newSelection)
}
</script>

<template>
    <div class="col-span-full flex flex-col gap-2">
        <Label :required="required" for="ticket-categories">{{ label }}</Label>
        <div class="flex flex-col gap-8">
            <div v-for="group in tickets" :key="group.workshop" class="flex flex-col gap-2">
                <span class="text-sm font-bold">{{ group.workshop }}</span>
                <div class="flex flex-wrap items-center gap-4 md:gap-6">
                    <div v-for="ticket in group.tickets" :key="ticket.value" class="flex items-center gap-2">
                        <Checkbox
                            :default-value="modelValue.includes(ticket.value)"
                            :value="ticket.value"
                            class="size-6"
                            :id="String(ticket.value)"
                            @update:model-value="handleCategory(ticket.value)"
                        />
                        <Label :for="String(ticket.value)">{{ $t(ticket.label) }}</Label>
                    </div>
                </div>
            </div>
        </div>

        <p v-if="error" class="text-destructive text-xs">{{ error }}</p>
    </div>
</template>
